import React from 'react';
import PropTypes from 'prop-types';
import {formatForClock} from '../datetimeFormatter';

import {defaultOptions} from '../lib/locale';

const FormattedDate = ({time, timezone, locale, format}) => {
  return (
    <React.Fragment>
      {formatForClock(time, timezone, {locale, format})}
    </React.Fragment>
  );
};

FormattedDate.defaultProps = {
  timezone: defaultOptions().timezone,
  locale: navigator.language
};

FormattedDate.propTypes = {
  time: PropTypes.instanceOf(Date).isRequired,
  timezone: PropTypes.string,
  locale: PropTypes.string,
  format: PropTypes.string
};

export default FormattedDate;
